import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Clock } from 'react-feather';
import moment from 'moment';
import { Badge } from '../../VuexyDesign/atoms/_index';
import TrackStatusBadgeReleases from '../MyTracks/TrackList/TrackStatusBadgeReleases';
import { Track } from '../../api';

const StatusForTrackDetailPage = ({
  isCurrentUser,
  track,
}: {
  isCurrentUser: boolean;
  track: Track;
}) => {
  const { t } = useTranslation('tracks');
  return (
    <>
      {isCurrentUser ? (
        <>
          <span>
            <TrackStatusBadgeReleases track={track} />
          </span>
        </>
      ) : (
        <>
          <span>
            <Badge
              color="light-info"
              pill
              text={`${t('myTracks:statuses.ScheduledOn')} ${moment(
                track?.release_date,
              ).format('DD/MM/YYYY')}`}
              icon={
                <span style={{ marginRight: '5px' }}>
                  <Clock size={11} style={{ marginRight: '3px' }} />
                </span>
              }
            />
          </span>
        </>
      )}
    </>
  );
};

export default StatusForTrackDetailPage;
